<template>
  <page :custom-style="pageStyle">
    <div class="mask"></div>
    <maple-nav-bar
      class="nav-bar"
      background="transparent"
      left-arrow-color="#fff"
      :left-arrow="!browerInfo.isMiniProgram"
      :safe-top-distance="statusBarHeight"
      @click-left="goBack"
    >
      <template v-if="showPopIM" #right>
        <div class="nav-right" @click="jumpPopService">
          <IconFont name="mc-icon-kefu" />
          <span class="text">{{ kfText }}</span>
        </div>
      </template>
    </maple-nav-bar>
    <!-- 店铺信息 -->
    <div class="shop-card">
      <div class="left">
        <div class="shop-name-license">
          <div class="name" @click.stop="goQualificationPage">
            {{ shop.name }}
          </div>
          <Tag
            v-for="(tag, index) in shop.shopTags"
            :key="`${tag.tag}-${index}`"
            class="shop-title-tag"
            has-border
            :has-background="!!tag.backgroundColor"
            :primary-color="tag.textColor"
            :secondary-color="tag.frameColor"
            :corner-radius="getTagCornerRadius(tag)"
            :bg-color="tag.backgroundColor"
            :font-size="getTagTextSize(tag)"
            :use-trans-scale="false"
          >
            {{ tag.tag }}
          </Tag>
        </div>
        <div class="tip">
          <div
            v-if="shop.saleLimitAmount && shop.saleLimitAmount !== '0'"
            class="condition"
          >
            满{{ shop.saleLimitAmount }}起送
          </div>
          <div
            v-if="
              shop.saleLimitAmount &&
              shop.saleLimitAmount !== '0' &&
              shop.openInfo &&
              shop.openInfo.open_time_remain
            "
            class="seperate"
          ></div>
          <div class="open-time">
            {{ shop.openInfo && shop.openInfo.open_time_remain }}
          </div>
        </div>
        <div class="desc"><span class="title">简介</span>{{ shop.desc }}</div>
        <div v-if="shop.isShowInvoiceWayText === 1" class="invoice">
          <span class="title">开票</span>
          <span
            v-if="shop.invoiceTag && shop.invoiceTag.tag"
            class="tag"
            :style="invoiceTagStyle"
          >
            {{ shop.invoiceTag.tag }}
          </span>
          <span class="text"> {{ shop.shopInvoiceWayText }}</span>
        </div>
      </div>
      <div class="right">
        <img :src="shop.logoUrl" :alt="shop.name" />
      </div>
    </div>
    <!-- 提示 -->
    <van-notice-bar
      v-if="shop.closeStoreTime"
      left-icon="volume-o"
      :text="shop.closeStoreTime"
      color="#FF711D"
      background="#fdfcec"
    />
    <!-- 店铺劵 -->
    <div v-if="coupons.length" class="coupons">
      <coupon
        v-for="coupon in coupons"
        :key="coupon.id"
        :value="coupon.value"
        :rule="coupon.rule"
        :title="coupon.title"
        :claim="coupon.claim"
        @claim="claimCouponHandler(coupon.id)"
      ></coupon>
    </div>
    <!-- 商品列表 -->
    <div class="goods-content">
      <div class="subcategory-wrap">
        <!-- 分类筛选 -->
        <sub-category
          :sub-list="subCategory"
          :active-index="activeSubCategory"
          @operating="switchClass"
        ></sub-category>
      </div>
      <div class="good-list-wrapper">
        <!-- 筛选 -->
        <template v-if="showSaleAreaGood">
          <SearchFilterBar
            :is-show-mask.sync="isShowMask"
            :all-sort.sync="allSort"
            :price-sort.sync="priceSort"
            :decrement.sync="decrement"
            :increment.sync="increment"
            :all-up.sync="allUp"
            :all-down.sync="allDown"
            :all-defalut.sync="allDefalut"
          ></SearchFilterBar>
        </template>
        <!-- 商品 -->
        <list-wrap
          ref="popListWrap"
          :goods-list="goodsList"
          :class2-index="activeSubCategory"
          :class2-list="subCategory"
          :sale-class2-id="saleClass2Id"
          :show-sale-area-good="showSaleAreaGood"
          :loading="listWrapLoading"
          :empty="listWrapEmpty"
          @classSwitch="switchSiblingClass"
          @bottomReGet="bottomReGet"
          @beforeAddcart="beforeAddcart"
        ></list-wrap>
        <!-- 筛选蒙尘 -->
        <template v-if="isShowMask">
          <FilterMask
            :is-show-mask.sync="isShowMask"
            :all-sort.sync="allSort"
            :price-sort.sync="priceSort"
            :decrement.sync="decrement"
            :increment.sync="increment"
            :all-up.sync="allUp"
            :all-down.sync="allDown"
            :all-defalut.sync="allDefalut"
          ></FilterMask>
        </template>
      </div>
    </div>
    <FilterWrap />
    <!-- 关店提示 -->
    <div
      v-if="shop.openInfo && shop.openInfo.close_remain"
      class="close-remain"
    >
      {{ shop.openInfo && shop.openInfo.close_remain }}
    </div>
    <!-- 购物车 -->
    <CartBar />
    <Verify
      :app-key="appKey"
      :env="PASSPORT_GATEWAY_ENV"
      :risk-id="riskInfo.riskId"
      :device-id="deviceId"
      :start="riskInfo.isShowVerifyModel"
      :scene="riskInfo.url"
      @callback-verified="callbackVerified"
    ></Verify>
  </page>
</template>
<script>
import { IM_TYPE } from '@/utils/enum'
import { mapState, mapActions } from 'vuex'
import { deviceId, appKey, weChatKfGray } from '@/defines/environment'
import { Verify } from '@mc/passport-h5-verify'
import Coupon from './widgets/Coupon'
import Tag from '@/common/widgets/good_tag'
import SubCategory from './widgets/SubCategory.vue'
import ListWrap from './widgets/ListWrap.vue'
import CartBar from './widgets/CartBar.vue'
import SearchFilterBar from './widgets/SearchFilterBar.vue'
import FilterMask from './widgets/FilterMask.vue'
import FilterWrap from './widgets/FilterWrap.vue'
import { PASSPORT_GATEWAY_ENV } from '@/defines/environment/config'

let bottomReGetTimeout
export default {
  components: {
    Coupon,
    Tag,
    SubCategory,
    ListWrap,
    CartBar,
    SearchFilterBar,
    FilterMask,
    FilterWrap,
    Verify
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      document.title = '店铺'
      vm.$store.commit('pop/updateShopId', to.query.pop_id)
      vm.queryConpon = {
        promotion_id: to.query.promotion_id,
        promote_type: to.query.promote_type
      }
      vm.clearData()
      vm.clearQueryData()
      vm.initQuerData(to.query)
      // 获取店铺基本信息
      vm.getPopInfo()
    })
  },
  data() {
    return {
      browerInfo: window.matrix,
      coupons: [],
      subCategory: [],
      activeSubCategory: 0,
      listWrapLoading: false, // 商品列表loading
      listWrapEmpty: false, // 商品列表为空缺省图
      goodsList: {
        ifFinished: false,
        list: [],
        query: {
          page: 1,
          sale_c1_id: '0',
          sale_c2_id: '0',
          score_type: 1,
          size: 10
        }
      },
      queryConpon: {
        promotion_id: '',
        promote_type: ''
      },
      saleAreaSub: {
        id: 'pop_sale_sub',
        name: '优惠专区',
        parent_id: 'pop_sale_sub',
        seq: 0
      },
      isShowMask: false,
      allSort: false,
      allUp: false,
      allDown: true,
      increment: true,
      decrement: true,
      priceSort: false,
      allDefalut: true,
      imGrayFlag: 0,
      groupId: '',
      showInvoiceAbsentNotice: false,
      biName: '',
      deviceId: deviceId,
      appKey: appKey,
      PASSPORT_GATEWAY_ENV
    }
  },
  computed: {
    ...mapState('pop', [
      'shop',
      'queryData',
      'searchSkuList',
      'hasFinished',
      'riskInfo'
    ]),

    pageStyle() {
      return {
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        backgroundImage: `url('${this.shop.bannerUrl}')`,
        backgroundPosition: 'top',
        backgroundSize: '100% auto',
        backgroundRepeat: 'no-repeat'
      }
    },
    showPopIM() {
      return !!this.groupId || !!this.imGrayFlag
    },
    kfText() {
      return weChatKfGray ? '管家企微' : '联系商家'
    },
    invoiceTagStyle() {
      return {
        backgroundColor: this.shop.invoiceTag?.backgroundColor || '',
        borderRadius: this.shop.invoiceTag?.cornerRadius
          ? `${this.shop.invoiceTag?.cornerRadius}px`
          : '',
        border: `1px solid ${this.shop.invoiceTag?.frameColor}`,
        color: this.shop.invoiceTag?.textColor
      }
    },
    showSaleAreaGood() {
      return this.activeSubCategory === 0 && this.hasQueryConponInfo
    },
    hasQueryConponInfo() {
      return !!this.queryConpon.promote_type && !!this.queryConpon.promotion_id
    },
    saleClass2Id() {
      return this.subCategory[this.activeSubCategory]
        ? String(this.subCategory[this.activeSubCategory].id)
        : ''
    }
  },
  watch: {
    searchSkuList: function (newVal) {
      if (this.showSaleAreaGood) {
        this.goodsList.ifFinished = this.hasFinished
        this.goodsList.list = newVal
        this.listWrapEmpty = this.goodsList.list.length === 0
        // this.listWrapLoading = false
      }
    }
  },
  methods: {
    ...mapActions('pop', [
      'getActivitySkuList',
      'setActQueryData',
      'getPopShop',
      'getGoodsBySaleClass2Id',
      'getPopGoods',
      'getPopCompanyCoupons',
      'getSaleClassify',
      'claimCoupon',
      'classInit',
      'clearQueryData',
      'getIMRoom',
      'clearRiskInfo'
    ]),
    getTagCornerRadius(tag) {
      return tag.cornerRadius === undefined || tag.cornerRadius === null
        ? 4
        : Number(tag.cornerRadius)
    },
    getTagTextSize(tag) {
      return tag.textSize === undefined || tag.textSize === null
        ? 10
        : Number(tag.textSize)
    },
    callbackVerified(params) {
      if (params.code < 8000) {
        if (this.riskInfo.url === 'pop/getShopIndexInfo') {
          this.getPopInfo()
        }
        this.clearRiskInfo()
      }
    },
    goBack() {
      this.$back()
    },
    jumpPopService() {
      this.$track(this.$trackMap.pop.popIm, {
        pop_id: Number(this.shop.id),
        kf_type: 3
      })
      if (this.groupId) {
        this.$nativeRedirect(this.$nativeRoutes.newIm, {
          type: IM_TYPE.POP_SERVICE,
          pop_name: this.shop.name,
          room_id: this.groupId
        })
      } else {
        this.getIMRoom({
          pop_id: this.shop.id
        })
          .then(res => {
            if (res.room_id) {
              this.$nativeRedirect(this.$nativeRoutes.newIm, {
                type: IM_TYPE.POP_SERVICE,
                pop_name: this.shop.name,
                room_id: res.room_id
              })
            } else {
              throw new Error('get pop room id error')
            }
          })
          .catch(e => this.$toast('进入商家客服失败，请稍后再试'))
      }
    },
    clearData() {
      this.allSort = false
      this.allUp = false
      this.allDown = true
      this.increment = true
      this.decrement = true
      this.priceSort = false
      this.maskTop = 0
      this.isShowMask = false
      this.allDefalut = true
      this.listWrapEmpty = false
      this.goodsList = {
        ifFinished: false,
        list: [],
        query: {
          page: 1,
          saleC1Id: '0',
          saleC2Id: '0',
          score_type: 1,
          size: 20
        }
      }
    },
    initQuerData(data) {
      this.setQueryData('page', 1)
      if (data.promotion_id) {
        this.setQueryData('promotionId', Number(data.promotion_id))
      }
      if (data.promote_rule_id) {
        this.setQueryData('promoteRuleId', Number(data.promote_rule_id))
      }
      if (data.promote_stage_id) {
        this.setQueryData('promoteStageId', Number(data.promote_stage_id))
      }
      if (data.promote_type) {
        this.setQueryData('promoteType', Number(data.promote_type))
      }
      this.setQueryData('actionId', Number(data.actionId || 0))
    },
    setQueryData(name, data) {
      const queryObj = {}
      queryObj[name] = data
      this.setActQueryData(queryObj)
    },
    getPopInfo() {
      this.getPopShop()
        .then(res => {
          if (res.pop_im_gray) this.imGrayFlag = res.pop_im_gray
          if (res.room_id) this.groupId = res.room_id
          document.title = (res && res.shop_name) || 'POP店铺'
          if (Array.isArray(res.shop_coupon_list)) {
            this.coupons = res.shop_coupon_list
              .filter(coupon => {
                if (coupon.participate_count === null) {
                  // 不限制领取次数
                  return true
                } else if (coupon.participate_count >= 1) {
                  // 还有可领取次数
                  return true
                } else if (coupon.has_participated_count) {
                  // 已经领过
                  return true
                } else {
                  // 没有可领取次数，且自己没领过
                  return false
                }
              })
              .map(coupon => ({
                id: coupon.coupon_id,
                value: coupon.amount,
                rule: `满${coupon.order_amount}可用`,
                title: '优惠券',
                deliveryId: coupon.activity_id,
                couponId: coupon.coupon_id,
                claim:
                  coupon.participate_count === null
                    ? false
                    : coupon.participate_count < 1
              }))
          } else {
            this.coupons = []
          }
          this.getSaleClass()
        })
        .catch(e => {
          if (e?.error?.code === 30000001) {
            // 被风控，不做任何处理
          } else {
            this.$catch(e)
          }
        })
    },
    getSaleClass() {
      // 获取商品分类和商品
      this.getSaleClassify()
        .then(res => {
          if (Array.isArray(res) && res.length) {
            this.subCategory = res
              .map((item, index) => ({
                id: item.sale_c2_id,
                name: item.sale_c2_name,
                parent_id: 0,
                seq: index
              }))
              .slice(0)

            if (
              this.hasQueryConponInfo &&
              Number(this.shop?.openInfo?.is_open) === 1
            ) {
              this.subCategory.splice(0, 0, this.saleAreaSub)
              this.classInit(this.queryData)
            }
          } else {
            return Promise.reject('no classes')
          }
        })
        .then(() => this.getShopGoods())
        .then(res => {
          this.setGoodList(res)
        })
        .catch(e => {
          console.log('e', e)
          if (e === 'no classes') {
            this.$toast('店铺暂无上架商品。')
          } else {
            if (e?.error?.code === 30000001) {
              this.goodsList.list = []
              this.listWrapEmpty = this.goodsList.list.length === 0
              this.listWrapLoading = false
            } else {
              this.$catch(e)
            }
          }
        })
    },
    goQualificationPage() {
      this.$router.push({
        name: 'popQualification',
        query: {
          pop_id: this.shop.id,
          title: '商家资质'
        }
      })
    },
    getShopGoods(data) {
      this.listWrapLoading = true
      if (this.showSaleAreaGood || (data && data.id === 'pop_sale_sub')) {
        return this.getActivitySkuList(this.queryData)
      } else {
        return this.getGoodsBySaleClass2Id({
          saleClass2Id:
            (data && data.id) ||
            (this.subCategory &&
              this.subCategory[this.activeSubCategory] &&
              this.subCategory[this.activeSubCategory].id) ||
            '',
          page: (data && data.page) || 1,
          size: this.goodsList.query.size
        })
      }
    },
    calcGoodList(list) {
      const calcSkuList = list.map(ssuItem => {
        const ssu = Object.assign({}, ssuItem, {
          isSingle: ssuItem?.ssuList?.length === 1
        })
        return ssu
      })
      return calcSkuList
    },
    setGoodList(res) {
      if (this.showSaleAreaGood) {
        this.goodsList.ifFinished = !!res?.isLast
        this.goodsList.list = res?.skuList || []
        this.goodsList.query = this.queryData
        this.goodsList.query.size = 10
        this.goodsList.query.page = 1
      } else {
        this.goodsList.ifFinished = !!res?.is_last_page
        this.goodsList.list = res?.rows || []

        this.goodsList.query.page = 1
        this.goodsList.query.size = 20
      }
      this.listWrapEmpty = this.goodsList.list.length === 0
      this.listWrapLoading = false
    },
    claimCouponHandler(id) {
      const coupon = this.coupons.find(coupon => coupon.id === id)
      this.$track(this.$trackMap.pop.popCouponBuv, {
        pop_id: Number(this.shop.id),
        big_activity_id: `${coupon.deliveryId}`
      })

      this.$Loading()
      this.claimCoupon({
        deliveryId: coupon.deliveryId,
        couponId: coupon.couponId
      })
        .then(() => {
          this.$Loading.hide()
          this.$toast('领取成功')
        })
        .then(() => this.getPopShop())
        .then(res => {
          if (Array.isArray(res.shop_coupon_list)) {
            this.coupons = res.shop_coupon_list
              .filter(coupon => {
                if (coupon.participate_count === null) {
                  // 不限制领取次数
                  return true
                } else if (coupon.participate_count >= 1) {
                  // 还有可领取次数
                  return true
                } else if (coupon.has_participated_count) {
                  // 已经领过
                  return true
                } else {
                  // 没有可领取次数，且自己没领过
                  return false
                }
              })
              .map(coupon => ({
                id: coupon.coupon_id,
                value: coupon.amount,
                rule: `满${coupon.order_amount}可用`,
                title: '优惠券',
                deliveryId: coupon.activity_id,
                couponId: coupon.coupon_id,
                claim:
                  coupon.participate_count === null
                    ? false
                    : coupon.participate_count < 1
              }))
          } else {
            this.coupons = []
          }
        })
        .catch(e => {
          this.$Loading.hide()
          this.$catch(e)
        })
    },
    switchClass(event) {
      const id = event.item.id
      this.activeSubCategory = event.index
      this.clearQueryData()
      this.clearData()
      this.getClassChangeData(id)
      this.$track(this.$trackMap.pop.popLeftNavUv, {
        pop_id: Number(this.shop.id),
        sale_class2_id: Number(event.index)
      })
    },
    getClassChangeData(id) {
      this.setQueryData('page', 1)
      this.goodsList.query.page = 1
      this.getShopGoods({ id }).then(res => {
        this.setGoodList(res)
        this.$refs.popListWrap.$refs.container.scrollTop = 0
      })
    },
    switchSiblingClass(event) {
      const direction = event.direction
      let index, id
      const subCategoryLength = this.subCategory.length - 1
      switch (direction) {
        case 'up':
          if (this.activeSubCategory === 0) {
            return
          }
          index = this.activeSubCategory - 1
          id =
            this.subCategory &&
            this.subCategory[index] &&
            this.subCategory[index].id
          break
        case 'down':
          if (this.activeSubCategory >= subCategoryLength) {
            return
          }
          index = this.activeSubCategory + 1
          id = this.subCategory[index].id
          break
      }
      this.activeSubCategory = index
      this.clearQueryData()
      this.clearData()
      this.getClassChangeData(id)
    },
    bottomReGet() {
      if (bottomReGetTimeout) {
        window.clearTimeout(bottomReGetTimeout)
      }
      bottomReGetTimeout = window.setTimeout(() => {
        const id = this.subCategory[this.activeSubCategory]
          ? this.subCategory[this.activeSubCategory].id
          : ''
        const page = this.goodsList.query.page + 1
        this.setQueryData('page', page)
        this.getShopGoods({ id, page }).then(res => {
          this.listWrapLoading = false
          if (this.showSaleAreaGood) {
            this.goodsList.query.size = 10
            this.goodsList.query.page = page
          } else {
            this.goodsList.ifFinished = !!res.is_last_page
            this.goodsList.list = this.goodsList.list.concat(res.rows || [])
            this.goodsList.query.page += 1
          }
        })
      }, 400)
    },
    beforeAddcart(name) {
      this.biName = name
      this.showInvoiceAbsentNotice = true
    }
  }
}
</script>
<style lang="scss" scoped>
.nav-bar {
  color: #fff;
  .text {
    margin-left: 0.1rem;
  }
}
.mask {
  position: absolute;
  top: 0;
  left: 0;

  width: 100%;
  height: 1.8rem;

  background-image: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0.6),
    rgba(0, 0, 0, 0.1)
  );
}
.shop-card {
  display: flex;

  position: relative;
  z-index: 1;

  padding: 0.3rem;

  background-color: #fff;

  flex-direction: row;

  border-top-left-radius: 0.2rem;
  border-top-right-radius: 0.2rem;

  .left {
    width: 0;

    flex: auto;

    .shop-name-license {
      display: flex;

      flex-direction: row;
      align-items: center;
      .name {
        font-size: 0.36rem;
        font-weight: 600;
        white-space: nowrap;
        color: #262626;

        text-overflow: ellipsis;

        overflow-x: hidden;
      }
      ::v-deep .shop-title-tag {
        margin-left: 0.16rem;

        align-self: center;
        flex: none;
      }
    }
    .tip {
      display: flex;

      margin-top: 0.1rem;

      flex-direction: row;
      align-items: center;

      font-size: 0.26rem;
      color: #262626;
      .condition {
        margin-right: 0.18rem;

        flex: none;
      }
      .seperate {
        width: 1px;
        height: 0.18rem;
        margin-right: 0.18rem;

        background-color: #ccc;

        flex: none;
      }
      .open-time {
        width: 0;

        flex: auto;
        @include text-overflow-ellipsis-single;
      }
    }
    .desc {
      margin-top: 0.2rem;

      font-size: 0.26rem;
      white-space: nowrap;
      color: #595959;
      text-overflow: ellipsis;

      overflow-x: hidden;
      .title {
        margin-right: 0.16rem;

        font-weight: 600;
        color: #262626;
      }
    }
    .invoice {
      display: flex;

      margin-top: 0.12rem;

      flex-direction: row;
      align-items: flex-start;

      font-size: 0.26rem;
      color: #595959;
      .title {
        margin-right: 0.16rem;

        font-weight: 600;
        white-space: pre;
        color: #262626;
      }
      .tag {
        margin-right: 0.08rem;
        padding: 0.04rem;

        flex: none;

        font-size: 0.2rem;
      }
      .text {
        @include text-overflow-ellipsis-multiple(3);
      }
    }
  }
  .right {
    display: inline-block;

    width: 1.2rem;
    height: 1.2rem;
    overflow: hidden;

    border-radius: 0.1rem;
    border: 1px solid #f8f8f8;

    flex: none;

    & > img {
      width: 100%;
      height: 100%;
    }
  }
}
.coupons {
  display: flex;

  padding: 0.2rem 0.32rem;
  overflow-x: auto;

  background-color: #fff;

  flex: none;

  flex-flow: row nowrap;

  ::v-deep .coupon {
    margin-right: 0.2rem;

    flex: none;
  }
}

.goods-content {
  display: flex;

  z-index: 2;

  height: 0;

  background-color: #fff;

  flex: auto;

  flex-flow: row nowrap;
  .subcategory-wrap {
    width: 1.64rem;
    overflow-y: auto;

    flex: none;

    ::v-deep .subcategory {
      position: relative;
      .subcategory-item {
        width: 100%;
      }
    }
  }
  .good-list-wrapper {
    display: flex;

    position: relative;

    width: 0;

    flex: auto;

    flex-direction: column;

    overflow-x: hidden;
  }
}
.close-remain {
  display: flex;

  width: 100%;
  height: 0.6rem;

  background-color: #fff0db;

  flex-direction: row;
  justify-content: center;
  align-items: center;

  font-size: 12px;
  color: rgba(255, 92, 0, 100);
}
</style>
